<ng-template #content let-modal>

      <div class="modal-header" style="  background: linear-gradient(to bottom, #F9F9FC 0%, #EEEEF4 100%);height: 50px;

      ">
        <h4 class="modal-title" id="modal-basic-title" style="font-size: 16px;
            font-weight: 500; color: black;">
          Save Document
        </h4>
        <button type="button"  aria-label="Close" class="button-close" (click)="closeModal()" style="border: none;background: linear-gradient(to bottom, #F9F9FC 0%, #EEEEF4 100%);">
            <span aria-hidden="true" style="    font-size: 30px;">
              &times;
            </span> </button>
      </div>
      <div class="modal-body" style="    padding: 33px 50px;;">
        <div style="height: 20px">
          <p class="text-left mb-2 w-100 float-left" id="savefiletext" style="color: green"> <i *ngIf="savefiletext"
              class="fas fa-check-circle me-1" style="margin-top: 0px; margin-left: 5px; "></i>{{ savefiletext }} </p>

          <p class="text-left mb-2 w-100 float-left" id="validation" style="color: red"> <i *ngIf="validation"
              class="fa fa-times-circle me-1" style="margin-top: 0px;margin-left: 5px;"></i>{{ validation }} </p>
        </div>
        <div class="mb-0" id="savefiletext1">
          <label for="file_name" id="saveFileLabel" style="margin-left: 4px !important ;    font-size: 16px;
                  font-weight: 500; color: black;" class="mb-2">Type title of file</label>
          <input class="form-control p-2" id="file_name" style="height: 50px" type="text"
            placeholder="Grammar Checker - (Grammar Editor)" onfocus="this.placeholder=''" onblur="this.placeholder='Grammar Checker - (Grammar Editor)'"
            [(ngModel)]="file_name" value="{{ docTitle }}" required (keyup)="saveFile($event)" />
        </div>
        <div class="modal-footer justify-content-start border-0 px-1  pb-4 ms-3 " id="saveSuccessmMsg">
          <button type="button" class="cancel me-4" data-dismiss="modal" (click)="closeModal()"> Cancel </button>
          <button type="submit" class=" submit mr-0" (click)="auto_Saved_for_Modal()"> Save </button>
        </div>
      </div>

</ng-template>